import Device from '../../../../../constants/deviceSizes';

export default {
  container: {
    width: '100%',
    minHeight: 80,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: 20
  },
  content: {
    marginLeft: 25
  },
  commentArea: {
    width: '88%',
    margin: '16px auto 0px',
    height: 100,
    [Device.mobile]: {
      width: '80%'
    }
  },
  containerNoComment: {
    minHeight: 'auto'
  },
  textAreaError: {
    paddingLeft: 25,
    marginTop: 5
  }
};
